import { safeSet } from './local-storage.js';
import { syncThemeColor } from './pwa.js';

// Add a new entry here (plus its matching [data-theme="..."] block in
// styles.css) to make another theme selectable - the menu list below
// renders itself from this array.
export const THEMES = [
    { id: 'oche-led', label: 'Oche LED' },
    { id: 'chalk-slate', label: 'Chalk & Slate' },
    { id: 'scoreboard-card', label: 'Scoreboard Card' },
    { id: 'brass-mahogany', label: 'Brass & Mahogany' },
    { id: 'matchday-mustard', label: 'Matchday Mustard' }
];
const THEME_STORAGE_KEY = 'halveren-theme';

export function applyTheme(id) {
    document.documentElement.setAttribute('data-theme', id);
    safeSet(THEME_STORAGE_KEY, id);
    syncThemeColor();
    renderThemeOptions();
}

// Each swatch carries its own `data-theme` attribute (the same attribute
// name/values styles.css already keys every theme's --surface/--primary/
// --secondary custom properties off of) - not because it IS the active
// theme, but because CSS custom properties inherit from wherever they're
// declared, so putting a theme's own [data-theme="X"] on its own swatch
// scopes that theme's colors to just that circle, regardless of which
// theme is actually active on <html>. The swatch's fill (.theme-swatch-fill)
// and the active ring both just reference var(--surface)/var(--primary)/
// var(--secondary) and inherit the right values automatically.
export function renderThemeOptions() {
    const container = document.getElementById('themeOptions');
    if (!container) return;
    const current = document.documentElement.getAttribute('data-theme');
    const currentTheme = THEMES.find((theme) => theme.id === current);

    container.innerHTML = `
        <div class="theme-swatches">
            ${THEMES.map((theme) => `
                <button class="theme-swatch${theme.id === current ? ' active' : ''}" data-theme="${theme.id}"
                    onclick="applyTheme('${theme.id}')" aria-label="${theme.label}" aria-pressed="${theme.id === current}">
                    <span class="theme-swatch-fill"></span>
                </button>
            `).join('')}
        </div>
        <div class="theme-selected-label">Selected: <span>${currentTheme ? currentTheme.label : ''}</span></div>
    `;
}
